var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-error-message",style:({height: _vm.height})},[_c('h3',[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }